<template>
  <step-display :current-step="NaN">
    <report1 />
  </step-display>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import StepDisplay from "@/components/global/StepDisplay";
import Report1 from "@/components/report/1";

export default {
  name: "1",
  components: {
    StepDisplay,
    Report1,
  },
  mounted() {
    let intervalID, loop = 0;
    const timer = () => loop ? 2000 : 1000;

    intervalID = setInterval(()=> {
      if (loop > 10) {
        clearInterval(intervalID);
        this.$router.push({ name: 'Connect Google',params: { support: true } });
      }
      if( this.get_report_return ) {
        clearInterval(intervalID);
        this.checkAndSetSingleDomain();
        this.redirectPage();
      }
      loop++;
    },timer())
  },
  computed: {
    ...mapGetters(['get_report_return', 'get_domains']),
  },
  methods: {
    ...mapMutations(['SET_SELECTED_DOMAIN']),

    redirectPage() {
      let name = (this.get_domains || []).length === 1
        ? 'Report 2 One Domain'
        : 'Report 2 Multiple Domains';

      this.$router.push({ name });
    },

    checkAndSetSingleDomain() {
      if ((this.get_domains || []).length === 1) {
        return this.SET_SELECTED_DOMAIN(this.get_domains[0]);
      }
    }
  }
}
</script>
